import { createRouter, createWebHashHistory } from 'vue-router'
import { routes as authRoutes, registerGuards as registerAuthGuards } from '@/modules/auth/router/index'
import { routes as pollRoutes } from '@/modules/poll/router/index'
import { routes as lrasRoutes } from '@/modules/lkLras/router/index'
import { routes as vacancyRoutes } from '@/modules/vacancy/router/index'
import Home from '../common/pages/Home.vue'
import ScanStub from '../common/pages/ScanStub.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { isPublic: true }
  },
  {
    path: '/scan/:code',
    name: 'ScanStub',
    component: ScanStub,
    meta: { isPublic: true, layout: 'ScanLayout' }
  },
  ...authRoutes,
  ...pollRoutes,
  ...lrasRoutes,
  ...vacancyRoutes
] 

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

registerAuthGuards(router)

export default router
